(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-2-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function populate(select, options, placeholder) {
    var html = '<option value="">' + placeholder + '</option>';
    options.forEach(function (opt) {
      var safe = opt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      html += '<option value="' + safe + '">' + safe + '</option>';
    });
    select.innerHTML = html;
  }

  function initFinder(root) {
    var brandEl = root.querySelector('[data-ck2h2="brand"]');
    var seriesEl = root.querySelector('[data-ck2h2="series"]');
    var modelEl = root.querySelector('[data-ck2h2="model"]');
    var submitEl = root.querySelector('[data-ck2h2="submit"]');
    var noteEl = root.querySelector('[data-ck2h2="note"]');
    if (!brandEl || !seriesEl || !modelEl || !submitEl || !noteEl) return;

    var noteDefaultHTML = noteEl.innerHTML;
    var data = null;

    function resetNote() {
      noteEl.classList.remove('ck2h2-note--prompt');
      noteEl.innerHTML = noteDefaultHTML;
    }

    fetch(root.dataset.ck2h2Src, { priority: 'low' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        data = json;
        populate(brandEl, Object.keys(data), 'Start with your printer brand');
        brandEl.disabled = false;
      })
      .catch(function () {
        noteEl.textContent = 'Ink finder is temporarily unavailable — please browse by brand instead.';
        noteEl.classList.add('ck2h2-note--prompt');
      });

    brandEl.addEventListener('change', function () {
      seriesEl.innerHTML = '<option value="">Now select your series</option>';
      modelEl.innerHTML = '<option value="">Finally choose your model</option>';
      seriesEl.disabled = true;
      modelEl.disabled = true;
      resetNote();
      if (!data || !brandEl.value) return;
      populate(seriesEl, Object.keys(data[brandEl.value] || {}), 'Now select your series');
      seriesEl.disabled = false;
    });

    seriesEl.addEventListener('change', function () {
      modelEl.innerHTML = '<option value="">Finally choose your model</option>';
      modelEl.disabled = true;
      resetNote();
      if (!data || !brandEl.value || !seriesEl.value) return;
      populate(modelEl, Object.keys(data[brandEl.value][seriesEl.value] || {}), 'Finally choose your model');
      modelEl.disabled = false;
    });

    modelEl.addEventListener('change', resetNote);

    submitEl.addEventListener('click', function () {
      var url = data && brandEl.value && seriesEl.value && modelEl.value
        ? data[brandEl.value][seriesEl.value][modelEl.value]
        : null;
      if (url) {
        window.location.href = url;
        return;
      }
      noteEl.textContent = 'Pick a brand, series and model above to continue.';
      noteEl.classList.add('ck2h2-note--prompt');
    });
  }

  document.querySelectorAll('.ck2h2-finder').forEach(initFinder);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia('(min-width: 1024px)').matches; // was theme.mediaQueries.md (769px) — footer now unified to the same 1024px breakpoint as the header, this must match or the accordion stays force-open below 1024px on page load
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Bug fix, 2026-07-22: the mobile drawer's "Find My Ink" CTA
     (.header__drawer-cta) has no click-close wiring in main.js — only
     the hamburger toggle button does. Normally that's invisible because
     the link's href is a real navigation (/#ink-finder from another
     page), which unloads the page and resets the drawer for free. From
     the homepage itself the same href is just a same-document hash
     jump — no unload happens, so the drawer stays open on top of the
     page and the anchor-scroll underneath is invisible. Explicitly
     closing the drawer here (reusing the main-menu element's own
     closeMainMenu, so it gets the same exit transition/aria/focus
     handling as pressing the toggle button) fixes both cases. */
  document.addEventListener('DOMContentLoaded', function () {
    var drawerCta = document.querySelector('.header__drawer-cta');
    var menu = document.querySelector('main-menu');
    if (!drawerCta || !menu) return;
    drawerCta.addEventListener('click', function () {
      if (typeof menu.closeMainMenu === 'function') {
        menu.closeMainMenu(true);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
